import { RangeDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { Check, Clock, Mail, MessageSquareText, RotateCcw, Search, Star, Trash2, UserCog } from 'lucide-react';

interface RangeActionHandlers {
    onView: (range: RangeDTO) => void;
    onDelete: (range: RangeDTO) => void;
    onSendEmail: (range: RangeDTO) => void;
    onViewAllEmails: (range: RangeDTO) => void;
    onViewRecordEmails: (range: RangeDTO) => void;
    onApprove: (range: RangeDTO) => void;
    onChangeStatus: (range: RangeDTO) => void;
}

const createRangeActions =
    (handlers: RangeActionHandlers) =>
        (row: RangeDTO): TableAction[] => {
            const actions: TableAction[] = [];
            const hasMember = row.member?.id || row.memberId;

            if (handlers.onSendEmail && hasMember) {
                actions.push({
                    label: 'Send Email',
                    onClick: () => handlers.onSendEmail(row),
                    icon: <Mail className="w-4 h-4" />,
                });
            }

            if (handlers.onViewAllEmails && hasMember) {
                actions.push({
                    label: 'Messages(All)',
                    onClick: () => handlers.onViewAllEmails(row),
                    icon: <Clock className="w-4 h-4" />,
                });
            }

            if (handlers.onViewRecordEmails) {
                actions.push({
                    label: 'Messages(Record)',
                    onClick: () => handlers.onViewRecordEmails(row),
                    icon: <Clock className="w-4 h-4" />,
                });
            }

            if (handlers.onApprove) {
                actions.push({
                    label: 'Approve?',
                    onClick: () => handlers.onApprove(row),
                    icon: <Check className="w-4 h-4" />,
                });
            }

            if (handlers.onChangeStatus) {
                actions.push({
                    label: 'Change Status?',
                    onClick: () => handlers.onChangeStatus(row),
                    icon: <Star className="w-4 h-4" />,
                });
            }

            return actions;
        };

export default createRangeActions;